import React, { useEffect, useState } from 'react';
import './Sidebar.scss';
import ArrowLeft from '../../../Assets/icons/ArrowLeft';
import walletIcon from '../../../Assets/icons/down-payment.svg';
import chargingIcon from '../../../Assets/icons/wireless-charging.svg';
import faqIcon from '../../../Assets/icons/information.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getHistoryListing, getHistoryMessages } from '../Redux/actionCreator';
import {
    resetExpireAllPayments,
    resetMessages,
    setLeoButton,
    setShowHistory,
} from '../Redux/reducer';
import dayjs from 'dayjs';

const Sidebar = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    const { historyList } = useSelector((store) => store.chatBot);

    const [groupedMessages, setGroupedMessages] = useState({});

    useEffect(() => {
        dispatch(getHistoryListing());
    }, [isOpen]);

    useEffect(() => {
        const today = dayjs();
        const yesterday = today.subtract(1, 'day');

        const grouped = {
            Today: [],
            Yesterday: [],
        };
        const others = {};

        historyList.forEach((item) => {
            const msgDate = dayjs(item.createdAt);
            const chatInput = item?.data?.chat_input;
            const botPersona = item?.data?.bot_persona;
            const sessionId = item?.session_id;

            if (!chatInput || !sessionId) return;

            const chatObj = {
                chat_input: chatInput,
                session_id: sessionId,
                bot_persona: botPersona,
            };

            if (msgDate.isSame(today, 'day')) {
                grouped.Today.push(chatObj);
            } else if (msgDate.isSame(yesterday, 'day')) {
                grouped.Yesterday.push(chatObj);
            } else {
                const dateLabel = msgDate.format('MMMM D, YYYY'); // Example: March 5, 2024
                if (!others[dateLabel]) {
                    others[dateLabel] = [];
                }
                others[dateLabel].push(chatObj);
            }
        });

        // Merge Today, Yesterday, and other dates in descending order
        const sortedKeys = Object.keys(others).sort(
            (a, b) =>
                dayjs(b, 'MMMM D, YYYY').valueOf() - dayjs(a, 'MMMM D, YYYY').valueOf()
        );

        const sortedOthers = {};
        sortedKeys.forEach((key) => {
            sortedOthers[key] = others[key];
        });

        setGroupedMessages({ ...grouped, ...sortedOthers });
    }, [historyList]);

    const handleChatClick = (sessionId, bot_persona) => {
        dispatch(getHistoryMessages(sessionId));
        dispatch(setLeoButton(bot_persona));
        dispatch(resetExpireAllPayments(true));
        onClose();
    };
    const handleNewChat = () => {
        dispatch(setShowHistory(false));
        dispatch(resetMessages());
        dispatch(setLeoButton(''));
        onClose();
    };

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
                <span onClick={onClose}>
                    <ArrowLeft />
                </span>
                <h3 className="sidebar-heading">Chats</h3>
            </div>

            <div
                style={{ display: 'flex', marginTop: '1rem' }}
                onClick={() => {
                    dispatch(setLeoButton('charging_assistant'));
                    onClose();
                }}
            >
                <img src={chargingIcon} alt="charging" className="bot-button-image" />
                <p className="bot-button-name" style={{ paddingTop: '1rem' }}>
                    Charging Assistant
                </p>
            </div>

            <div
                style={{ display: 'flex', marginTop: '1rem' }}
                onClick={() => {
                    dispatch(setLeoButton('payment_assistant'));
                    dispatch(resetExpireAllPayments(false));
                    onClose();
                }}
            >
                <img
                    src={walletIcon}
                    alt="Payment Assistant Icon"
                    className="bot-button-image"
                />
                <p className="bot-button-name" style={{ paddingTop: '1rem' }}>
                    Payment Assistant
                </p>
            </div>

            <div
                style={{ display: 'flex', marginTop: '1rem' }}
                onClick={() => (dispatch(setLeoButton('faq_assistant')), onClose())}
            >
                <img
                    src={faqIcon}
                    alt="FAQ Assistant Icon"
                    className="bot-button-image"
                />
                <p className="bot-button-name" style={{ paddingTop: '1rem' }}>
                    Faq Assistant
                </p>
            </div>

            {/* Chat history list */}
            <div className="chat-list">
                {Object.keys(groupedMessages).map(
                    (key) =>
                        groupedMessages[key]?.length > 0 && (
                            <div className="chat-section" key={key}>
                                <p className="chat-date">{key}</p>
                                {groupedMessages[key].map((msg, i) => (
                                    <div
                                        className="chat-item"
                                        key={i}
                                        onClick={() =>
                                            handleChatClick(
                                                msg.session_id,
                                                msg.bot_persona
                                            )
                                        }
                                    >
                                        {msg.chat_input}
                                    </div>
                                ))}
                            </div>
                        )
                )}
            </div>

            <button className="new-chat-btn" onClick={handleNewChat}>
                + New Chat
            </button>
        </div>
    );
};

export default Sidebar;
